import { Button, Grid, styled, Theme } from '@mui/material'
import { SxProps } from '@mui/system'
const buttonStyle = (theme: Theme) => ({
    borderRadius: 0,
    width: '100%',
    margin: 5,
    height: 90,
    fontSize: 28,
    boxShadow: 'none',
    border:
        theme.palette.mode === 'light'
            ? 'none'
            : '1px rgba(255, 255, 255, 0.5) solid',
    color: theme.palette.default.contrastText,
    backgroundColor: theme.palette.default.dark,
    '&:hover': {
        background: theme.palette.primary.main,
        color: 'white',
    },
    [theme.breakpoints.down('lg')]: {
        height: 75,
    },
    '@media (max-height: 820px)': {
        fontSize: 24,
        height: 68,
        margin: 4,
    },
    '@media (max-height: 730px)': {
        fontSize: 22,
        height: 54,
        margin: 3,
    },
    '@media (max-height: 680px)': {
        fontSize: 22,
        height: 44,
        margin: 2,
    },
})
export const SidePadButton = styled(Button)(({ theme }) => ({
    ...buttonStyle(theme),
    width: undefined,
    border:
        theme.palette.mode === 'light'
            ? 'none'
            : '1px rgba(255, 255, 255, 0.5) solid',
    color: theme.palette.default.contrastText,
    backgroundColor: theme.palette.default.main,
    '&:hover': {
        background: theme.palette.primary.main,
        color: 'white',
    },
}))

export const NumPadButton = styled(Button)(({ theme }) => ({
    ...buttonStyle(theme),
}))

export const RedeemButton = styled(Button)(({ theme }) => ({
    borderRadius: 0,
    width: '100%',
    margin: 5,
    height: 60,
    fontSize: 18,
    color: theme.palette.default.contrastText,
    boxShadow: 'none',
    border:
        theme.palette.mode === 'light'
            ? 'none'
            : '1px rgba(255, 255, 255, 0.5) solid',
    '&:hover': {
        background: theme.palette.secondary.main,
        color: 'white',
    },
    [theme.breakpoints.down('lg')]: {
        height: 45,
    },
}))

export const TotalAmountBox = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    margin: '0.5rem',
    height: 80,
    borderRadius: 4,
    textAlign: 'end',
    [theme.breakpoints.down('md')]: {
        height: 40,
    },
    alignItems: 'center',
    padding: '0.5rem',
}))

export const TextBox = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.palette.topside.paper,
    margin: 10,
    height: 50,
    borderRadius: 4,
    textAlign: 'end',
    [theme.breakpoints.down('lg')]: {
        height: 40,
    },
    border: `1px solid ` + theme.palette.primary.main,
}))

// NOTE: use for credit card panel for mobile
export const TextBoxMobile = styled(Grid)(({ theme }) => ({
    backgroundColor: theme.palette.topside.paper,
    margin: 10,
    height: 70,
    borderRadius: 4,
    textAlign: 'end',
    [theme.breakpoints.down('lg')]: {
        height: 40,
    },
    border: `1px solid ` + theme.palette.secondary.light,
}))

export const QuickButton = styled(Button)(({ theme }) => ({
    fontSize: 16,
    marginBottom: 5,
    marginRight: 10,
    boxShadow: 'none',
    border: '1px solid ' + theme.palette.outlinePrimary.dark,
    color: theme.palette.outlinePrimary.contrastText,
    backgroundColor: theme.palette.outlinePrimary.main,
    height: 60,
    '&:hover': {
        background: theme.palette.outlinePrimary.dark,
        color: 'white',
    },
    [theme.breakpoints.down('md')]: {
        width: 70,
        height: 40,
    },
    [theme.breakpoints.down('lg')]: {
        width: 100,
        height: 40,
    },
}))

export const textFontStyle: SxProps<Theme> = {
    fontSize: {
        xs: 16,
        lg: 20,
    },
}
